import React from 'react';
import PropTypes from 'prop-types';
import { Grid2 as Grid } from '@mui/material';
import { SectionHeader } from 'components/molecules';
import { CardBase, ContactForm } from 'components/organisms';

const Contact = props => {
  const { className, ...rest } = props;

  return (
    <div className={className} data-aos="fade-up" {...rest}>
      <Grid container spacing={4}>
        <Grid size={{xs:12, md:6}}>
          <SectionHeader
            title="Ready for collaboration?"
            subtitle="We can explore options to make it happen."
            align="left"
            disableGutter
          />
        </Grid>
        <Grid size={{xs:12, md:6}}>
          <CardBase withShadow liftUp>
            <ContactForm />
          </CardBase>
        </Grid>
      </Grid>
    </div>
  );
};

Contact.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default Contact;
